import * as Map from '../util/Map';

export default function useAppsByAppName(apps:any, appStatus:any) {
  return {
    data: Map.appsToAppsByName(apps),
    apiStatus: appStatus
  };
}
